import { PAID_PLANS_APP_ID } from '@wix/communities-forum-universal/dist/src/constants/appsConfig';

export function getPaidPlansSectionUrl(wixCodeApi) {
  return (
    wixCodeApi.site.getSiteStructure().pages.find(page => page.applicationId === PAID_PLANS_APP_ID)
      .url || ''
  );
}
